<template>
  <div class="max-w-6xl">
    <div class="mb-4 text-sm text-gray-500">
      <span>Incoming call to </span>
      <a
        :href="`/phone_numbers/${incomingCall.phone_id}/edit`"
        class="font-semibold hover:text-blue-600">
        {{ incomingCall.display_name }}
      </a>
      {{ `/${incomingCall.phone_number} on ${incomingCall.received}.` }}
    </div>
    <div class="flex items-center w-full">
      <div class="flex flex-col w-60 h-20 items-start justify-center text-left">
        <div class="flex items-center mb-2">
          <span>Dialed</span>

          <fwb-tooltip class="ml-2" theme="light">
            <template #trigger>
              <svg class="w-[16px] h-[16px] text-sky-500 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.529 9.988a2.502 2.502 0 1 1 5 .191A2.441 2.441 0 0 1 12 12.582V14m-.01 3.008H12M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
            </template>
            <template #content>
              <span class="text-sm text-gray-500">
                This is your call tracking number that the caller dialed.
              </span>
            </template>
          </fwb-tooltip>
        </div>

        <p class="font-bold">
          {{ incomingCall.phone_number }}
        </p>
      </div>
      <div class="flex flex-col w-60 h-20 items-start justify-center text-left">
        <div class="flex items-center mb-2">
          <span>Caller</span>

          <fwb-tooltip class="ml-2" theme="light">
            <template #trigger>
              <svg class="w-[16px] h-[16px] text-sky-500 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.529 9.988a2.502 2.502 0 1 1 5 .191A2.441 2.441 0 0 1 12 12.582V14m-.01 3.008H12M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
            </template>
            <template #content>
              <span class="text-sm text-gray-500">
                This is the number of the caller.
              </span>
            </template>
          </fwb-tooltip>
        </div>

        <p class="font-bold">
          {{ incomingCall.from }}
        </p>
      </div>
      <div class="flex flex-col w-60 h-20 items-start justify-center text-left">
        <div class="flex items-center mb-2">
          <span>From</span>

          <fwb-tooltip class="ml-2" theme="light">
            <template #trigger>
              <svg class="w-[16px] h-[16px] text-sky-500 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.529 9.988a2.502 2.502 0 1 1 5 .191A2.441 2.441 0 0 1 12 12.582V14m-.01 3.008H12M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
            </template>
            <template #content>
              <span class="text-sm text-gray-500">
                This is the adress of the caller.
              </span>
            </template>
          </fwb-tooltip>
        </div>

        <p class="font-bold">
          {{ incomingCall.from_address }}
        </p>
      </div>
      <div class="flex flex-col w-60 h-20 items-start justify-center text-left">
        <div class="flex items-center mb-2">
          <span>Forwarded to</span>

          <fwb-tooltip class="ml-2" theme="light">
            <template #trigger>
              <svg class="w-[16px] h-[16px] text-sky-500 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.529 9.988a2.502 2.502 0 1 1 5 .191A2.441 2.441 0 0 1 12 12.582V14m-.01 3.008H12M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
            </template>
            <template #content>
              <span class="text-sm text-gray-500">
                The call was forwarded to this number.
              </span>
            </template>
          </fwb-tooltip>
        </div>

        <p class="font-bold">
          {{ incomingCall.forwarded_to_number }}
        </p>
      </div>
      <div class="flex flex-col w-60 h-20 items-start justify-center text-left">
        <div class="flex items-center mb-2">
          <span>Call status</span>

          <fwb-tooltip class="ml-2" theme="light">
            <template #trigger>
              <svg class="w-[16px] h-[16px] text-sky-500 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.529 9.988a2.502 2.502 0 1 1 5 .191A2.441 2.441 0 0 1 12 12.582V14m-.01 3.008H12M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
            </template>
            <template #content>
              <span class="text-sm text-gray-500">
                The call status indicates the state of the incoming call.
              </span>
            </template>
          </fwb-tooltip>
        </div>

        <p class="font-bold">
          <fwb-tooltip
            theme="light">
            <template #trigger>
              <p v-if="callSucceeded()"
                class="inline-block text-left text-green-500 rounded dark:bg-green-900 dark:text-green-300">

                {{ humanize(incomingCall.call_status) }}
              </p>

              <p v-else
                class="inline-block text-left text-red-500 rounded dark:bg-red-900 dark:text-red-300">

                {{ humanize(incomingCall.call_status || 'Failed') }}
              </p>
            </template>
            <template #content>
              <span class="text-sm text-gray-500">
                {{ incomingCall.call_status_details }}
              </span>
            </template>
          </fwb-tooltip>
        </p>
      </div>

      <div v-if="incomingCall.call_status === 'answered'">
        <div class="flex flex-col w-60 h-20 items-start justify-center text-center">
          <div class="flex items-center mb-2">
            <span>Duration</span>

            <fwb-tooltip class="ml-2" theme="light">
              <template #trigger>
                <svg class="w-[16px] h-[16px] text-sky-500 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.529 9.988a2.502 2.502 0 1 1 5 .191A2.441 2.441 0 0 1 12 12.582V14m-.01 3.008H12M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>
              </template>
              <template #content>
                <span class="text-sm text-gray-500">
                  This tracks how long the call lasted.
                </span>
              </template>
            </fwb-tooltip>
          </div>

          <p class="font-bold">
            {{ convertSecondsToTime(incomingCall.total_call_duration) }}
          </p>
        </div>
      </div>
      <div v-else-if="incomingCall.call_status === 'voicemail'">
        <div class="flex flex-col w-60 h-20 items-start justify-center text-center">
          <div class="flex items-center mb-2">
            <span>VM Length</span>

            <fwb-tooltip class="ml-2" theme="light">
              <template #trigger>
                <svg class="w-[16px] h-[16px] text-sky-500 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.529 9.988a2.502 2.502 0 1 1 5 .191A2.441 2.441 0 0 1 12 12.582V14m-.01 3.008H12M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>
              </template>
              <template #content>
                <span class="text-sm text-gray-500">
                  The recording length of the voicemail.
                </span>
              </template>
            </fwb-tooltip>
          </div>

          <p class="font-bold">
            {{ convertSecondsToTime(incomingCall.recording_length) }}
          </p>
        </div>
      </div>
    </div>

    <div class="mt-6">
      <div class="mb-4">
        <p class="mb-2">
          {{ recordingTitle() }}
        </p>

        <div v-if="!!incomingCall.recording_url">
          <audio controls class="audio-player">
            <source :src="incomingCall.recording_url" type="audio/mpeg">
          </audio>
        </div>
        <div v-else>
          <fwb-tooltip class="ml-2" theme="light">
            <template #trigger>
              <svg class="w-[32px] h-[32px] text-red-500 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-width="0.4" d="m6 6 12 12m3-6a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
            </template>
            <template #content>
              <span class="text-sm text-gray-500">
                {{ recordingTitle() }} not available
              </span>
            </template>
          </fwb-tooltip>

        </div>
      </div>

      <div v-if="incomingCall.recording_type === 'voicemail' && transcriptionPresent">
        <p class="mb-2">
          Transcription
        </p>

        <div v-if="!!transcription" class="text-sm text-gray-800">
          {{ transcription }}
        </div>
        <div v-else>
          <svg class="w-[32px] h-[32px] text-red-500 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-width="0.4" d="m6 6 12 12m3-6a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </div>
      </div>
    </div>

    <div class="mt-6">
      <fwb-table striped class="mt-2">
        <fwb-table-head>
          <fwb-table-head-cell>Event</fwb-table-head-cell>
          <fwb-table-head-cell>Time</fwb-table-head-cell>
        </fwb-table-head>
        <fwb-table-body>
          <fwb-table-row v-for="(item, index) in callEvents" :key="index">
            <fwb-table-cell>{{ humanize(item.event_type) }}</fwb-table-cell>
            <fwb-table-cell class="text-left !text-left">
              {{ item.occurrence_time }}
            </fwb-table-cell>
          </fwb-table-row>
        </fwb-table-body>
      </fwb-table>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { FwbTooltip,
  FwbTable,
  FwbTableBody,
  FwbTableCell,
  FwbTableHead,
  FwbTableHeadCell,
  FwbTableRow
} from 'flowbite-vue'
import { humanize } from '~/javascript/utils/strings'

const props = defineProps({
  incomingCall: {
    type: Object,
    required: true
  }
})

const incomingCall = ref(props.incomingCall)
const transcription = ref(props.incomingCall.transcription)
const transcriptionPresent = ref(props.incomingCall.transcription_present)
const callEvents = ref(props.incomingCall.call_events)

function callSucceeded() {
  return incomingCall.value.call_status === 'answered' || incomingCall.value.call_status === 'voicemail'
}

function convertSecondsToTime(seconds) {
  if (!seconds) {
    return 'N/A'
  }

  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const remainingSeconds = seconds % 60

  const timeParts = []

  if (hours > 0) {
    timeParts.push(`${hours} hour${hours > 1 ? 's' : ''}`)
    if (minutes > 0) {
      timeParts.push(`${minutes} minute${minutes > 1 ? 's' : ''}`)
    }
  } else if (minutes > 0) {
    timeParts.push(`${minutes} minute${minutes > 1 ? 's' : ''}`)
  }

  timeParts.push(`${remainingSeconds} second${remainingSeconds !== 1 ? 's' : ''}`)

  return timeParts.join(', ')
}

function recordingTitle() {
  return incomingCall.value.recording_type === 'voicemail' || incomingCall.value.call_status === 'voicemail' ? 'Voicemail' : 'Call Recording'
}

</script>

<style scoped>
.audio-player {
    width: 100%;
}
</style>
